import { AnchorHTMLAttributes } from 'react';

import * as S from './style';

export interface ButtonCloseProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  color?: string;
  size?: number;
}

export default function ButtonClose({ color, size = 22, ...props }: ButtonCloseProps) {
  return <S.ButtonClose color={color} size={size} {...props} />;
}
